import axios from "axios";
import { useMutation } from '@tanstack/react-query';
import { apiUrl } from "../../config";

export const useGetPoolPickStats = () => {
    return useMutation({
        mutationFn: getPoolPickStats,
        onError: (error) => {
            console.error('Error fetching pool pick stats:', error);
        },
        // onSuccess: (data) => {
        //     console.log('Successfully fetched pool pick stats:', data);
        // }
    });
}

const getPoolPickStats = async ({ gameID }) => {
    const data = { gameID };
    const response = await axios.post(`${apiUrl}/sports-data/get-pool-picks-stats-from-redis`, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    return response.data;
}